<nz-modal [nzVisible]="true" (nzOnCancel)="handleCancel()" [nzClosable]="true" [nzStyle]="{ top: 0, padding: 0 }"
    [nzBodyStyle]="{ padding: '0', height: '85vh' }" [nzCentered]="true"
    [nzMaskStyle]="{ backgroundColor: 'rgba(0,0,0,0.45)' }" [nzTitle]="titleTemplate" [nzWidth]="'100%'"
    nzClassName="full-screen-modal">
    <ng-container *nzModalContent nzClassName="content">
        <div *ngIf="page === 0">
            <div class="brand-select-body-wrapper">
                <nz-table #nzTable class="premium-table mt-2" [nzData]="listOfCurrentPageData"
                    [nzScroll]="{ y: 'calc(100vh - 220px)' }" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzLoading]="loadingListData" [nzTableLayout]="'fixed'" [nzSize]="'middle'" [nzBordered]="false"
                    [nzRowSelection]="{
                    type: 'checkbox',
                    selectedRowKeys: selectedBrandKeyList,
                    onChange: onRowSelectionChange
                    }">
                    <thead>
                        <tr class="table-header">
                            <!-- <th nzWidth="30px"></th> -->
                            <th [nzSelections]="listOfSelection" [nzChecked]="checked" [nzIndeterminate]="indeterminate"
                                [nzDisabled]="this.renewalEditRequest" nz-tooltip
                                [nzTooltipTitle]="this.renewalEditRequest ? 'Cannot edit a renewal investment' : ''"
                                (nzCheckedChange)="onAllChecked($event)" nzWidth="30px"></th>
                            <th nzWidth="150px" [nzShowSort]="true" (nzSortOrderChange)="sort('BrandName', $event)">
                                Brand</th>
                            <!-- <th nzWidth="150px">PRODUCT</th> -->
                            <th nzWidth="150px" nzAlign="right" class="pr-50">Price</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="!loadingListData">
                        <!-- <tr>
                            <td colspan="3"></td>
                        </tr> -->
                        <ng-container *ngFor="let data of nzTable.data">
                            <tr [nzSelected]="setOfCheckedId.has(data.id)"
                                (click)="data.brandInvestmentDetail?.isRenewal ? null : onBrandRowClick(data)"
                                class="premiumParent">
                                <!-- <td [nzExpand]="expandSet.has(data.id)"
                                    (nzExpandChange)="onExpandChange(data.id, $event, data)" nzWidth="30px"></td> -->
                                <td [nzChecked]="setOfCheckedId.has(data.id)"
                                    [nzDisabled]="data.brandInvestmentDetail?.isRenewal" nz-tooltip
                                    [nzTooltipTitle]="data.brandInvestmentDetail?.isRenewal ? 'Cannot edit a renewal investment' : ''"
                                    (nzCheckedChange)="onItemChecked(data.id, $event)" nzWidth="30px"></td>
                                <td class="fw-bold">{{ data.brandName }}</td>
                                <!-- <td class="fw-bold">{{ 'Current Listings(' + data.products.length + ')' }}</td> -->
                                <td nzAlign="right" class="fw-bold pr-50">{{ data.brandAmount | currency }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tbody *ngIf="loadingListData">
                        <tr *ngFor="let i of [].constructor(15)">
                            <ng-container *ngFor="let i of [].constructor(3)">
                                <td [nzAlign]="'left'" class="loading">
                                    <div class="bar"></div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>

        <div *ngIf="page === 1">
            <div class="brand-select-body-wrapper">
                <nz-table #nzTable class="premium-table mt-2" [nzData]="reviewData"
                    [nzScroll]="{ y: 'calc(100vh - 220px)' }" [nzFrontPagination]="false" [nzShowPagination]="false"
                    [nzTableLayout]="'fixed'" [nzSize]="'middle'" [nzBordered]="false" [nzRowSelection]="{
                    type: 'checkbox',
                    selectedRowKeys: selectedBrandKeyList,
                    onChange: onRowSelectionChange
                    }">
                    <thead>
                        <tr class="table-header">
                            <th nzWidth="150px">Brand</th>
                            <th nzWidth="150px">Estimated Renewal Date</th>
                            <th nzWidth="150px" nzAlign="right" class="pr-50">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let data of nzTable.data">
                            <tr [nzSelected]="setOfCheckedId.has(data.id)" class="premiumParent">
                                <td class="fw-bold">{{ data.brandName }}</td>
                                <td class="fw-bold">{{currentNextMonthYear}}</td>
                                <td nzAlign="right" class="fw-bold pr-50">{{ data.brandAmount | currency }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </nz-table>
            </div>
        </div>

        <div *ngIf="page === 2">
            <div class="request-invoice-body-wrapper">
                <div class="form-container">
                    <!-- Company Information Section -->
                    <nz-skeleton *ngIf="!companyDetails"></nz-skeleton>
                    <div class="company-section" *ngIf="companyDetails">
                        <div class="company-title">{{companyDetails.name || ''}}</div>
                        <div>{{companyDetails.address1 || ''}}</div>
                        <div>{{companyDetails.address2 || ''}}</div>
                        <div>
                            {{companyDetails.city ? companyDetails.city : ''}} {{companyDetails.city &&
                            companyDetails.state ? ', ' : ''}}
                            {{companyDetails.state ? companyDetails.state : ''}} {{companyDetails.state &&
                            companyDetails.zip ? ' ' : ''}}
                            {{companyDetails.zip ? (companyDetails.zip | mask: '00000-0000') : ''}}</div>
                        <div>{{companyDetails.country || ''}}</div>
                    </div>
                    <form nz-form [formGroup]="_fS.retailProgramInvestmentForm">
                        <!-- Supplier Rep Section -->
                        <div class="supplier-row mt-3">
                            <div style="flex: 1;">
                                <nz-form-item>
                                    <nz-form-control [nzErrorTip]="investorError">
                                        <label class="label-text required">Supplier Rep</label>
                                        <!-- (ngModelChange)="getInvestorTerms($event);getInvestorDetails($event)" -->
                                        <nz-select nzShowSearch nzPlaceHolder="Select Rep" [nzSize]="'default'"
                                            class="h-45" formControlName="rep" [nzSelectOnTab]="true">
                                            <ng-container *ngFor="let option of listOfReps">
                                                <nz-option *ngIf="!isLoading" [nzValue]="option.id"
                                                    [nzLabel]="option.name + ' | '+ option?.email">
                                                </nz-option>
                                            </ng-container>
                                            <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                                Loading Data...
                                            </nz-option>
                                        </nz-select>
                                        <ng-template #investorError let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please select
                                                rep</ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>

                            <div style="margin-top: 24px;">
                                <button nz-button nzType="default" (click)="openNewRepModal()">
                                    New Rep
                                </button>
                            </div>

                            <div class="amount-section">
                                <div class="amount-label">Amount to Pay</div>
                                <div class="amount-value">{{amountToPay | currency}}</div>
                            </div>
                        </div>

                        <!-- Invoice Description Section -->
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text">Invoice Description</label>
                                <div class="retailProgramDescriptionTitle">
                                    {{programDetail?.name + " Premium Content"}}
                                </div>
                                <div class="description-box">
                                    <textarea nz-input formControlName="detailedDescription" rows="3"
                                        placeholder="Enter description...">
                                    </textarea>
                                </div>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Accounting Notes Section -->
                        <nz-form-item>
                            <nz-form-control>
                                <!-- (keydown.enter)="preventEnter($event)"  -->
                                <label class="label-text">Accounting Notes</label>
                                <textarea type="text" nz-input formControlName="accountingNotes"
                                    placeholder="Add notes here" rows="2" maxlength="1000"></textarea>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Agreement Checkbox -->
                        <nz-form-item>
                            <nz-form-control>
                                <div class="d-flex align-flex-start">
                                    <label nz-checkbox formControlName="isAgreed" class="pr-1">
                                    </label>
                                    <div>
                                        <label class="required"></label>
                                    </div>
                                    <span class="checkbox-content cursor"
                                        (click)="_fS.retailProgramInvestmentForm.get('isAgreed').patchValue(!_fS.retailProgramInvestmentForm.get('isAgreed').value)">
                                        An invoice will be emailed to the Supplier rep selected above within 1 business
                                        day. Wine.com Premium
                                        Marketing will not be turned on until
                                        payment has been received. Payment options will be listed on the invoice. If you
                                        have any questions prior to submitting
                                        this invoice, please send us an email at
                                        <a href="mailto:wine.com-support@imiagency.com"
                                            class="support-link">{{'wine.com-support@imiagency.com'}}</a>
                                    </span>
                                </div>
                            </nz-form-control>
                        </nz-form-item>
                    </form>
                </div>
            </div>
        </div>
    </ng-container>
    <div *nzModalFooter>
        <div class="footer-wrapper">
            <button class="default-btn" nz-button (click)="page == 0 ? handleCancel() : handleGoBack()">{{page == 0 ?
                "Cancel" :
                "Back"}}</button>
            <button *ngIf="page === 0 || page === 1" nz-button (click)="handleOk(page+1)">Next </button>
            <button *ngIf="page === 2" nz-button (click)="scheduleInvestment()"
                [nzLoading]="investmentLoading">Submit</button>
        </div>
    </div>
</nz-modal>


<!--modal to create new investor-->
<nz-drawer [nzVisible]="showInvestorModal" (nzOnClose)="handleCancelInvestor()" [nzTitle]="'New Rep'" [nzWidth]="800"
    [nzMaskClosable]="false" nzClassName="investorModal investor-modal-box-main">
    <div *nzDrawerContent>
        <div class="">
            <h4 class="modal-sub-title pt-20">Create New Rep for {{supplierDetails?.investorDisplayName}}</h4>
        </div>
        <app-add-investor-form [IsDrawer]="true" [existingReps]="listOfReps" (investorData)="newCreatedInvestor($event)"
            [ParentCompanyDetails]="companyDetails"></app-add-investor-form>
    </div>
</nz-drawer>


<ng-template #titleTemplate>
    <div nz-row style="align-items: center;">
        <div nz-col [nzSpan]="8">
            <span class="Investment-modal-status ml-1" style="font-size: 130%;">
                Purchase Premium
            </span>
        </div>
        <div nz-col [nzSpan]="10">
            <nz-steps [nzCurrent]="progressBar" nzProgressDot>
                <nz-step nzTitle="Select Brands"></nz-step>
                <nz-step nzTitle="Review Brands"></nz-step>
                <nz-step nzTitle="Request Invoice"></nz-step>
            </nz-steps>
        </div>
    </div>
</ng-template>